import script from "./AgentChooseSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentChooseSection.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import SelectionCard from "@/components/neue/wizard/SelectionCard.vue";
import WizardSection from "@/components/neue/wizard/WizardSection.vue";
script.components = Object.assign({}, { SelectionCard, WizardSection }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { SelectionCard, WizardSection }, script.__o.components);}